/* eslint-disable */
import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import { toJS } from 'mobx';
import * as constants from '../../../common/constants';

const allRoles = types.model('AllRoles', {
  role: types.maybeNull(types.string),
  roleId: types.maybeNull(types.number),
  description: types.maybeNull(types.string),
  permissions: types.maybeNull(types.array(types.string), []),
  tenantId: types.maybeNull(types.string)
});

const ChatutilityRoles = types
  .model('ChatutilityRoles', {
    data: types.optional(types.array(allRoles), []),
    success: types.maybeNull(types.string)
  })
  .actions((self) => ({
    fetch(tenantId = '') {
      const dataToSend = {
        tenantId: tenantId
      };
      Framework.getEventManager().publish(constants.GET_USER_ROLES_TENANT, dataToSend);
    },
    set(response) {
      const plainData = toJS(response.data);
      applySnapshot(self.data, plainData);
    }
  }));

export default ChatutilityRoles;
